export default {"src":"/_next/static/media/metamask.ba540ba0.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};